export default __webpack_public_path__ + "static/media/evas04.b07f682f.jpg";